export default __webpack_public_path__ + "static/media/portfolio_03.4784beb0.png";